// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__39VN6","title":"Images90_title__2Z8as","images":"Images90_images__2nGNz"};